var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 4.65802L8.57857 8.89172M4.66429 2.70401L0.75 4.65802V13.426L8.57857 17.6597L16.4071 13.426V4.65802L8.57857 0.75L4.66429 2.70401ZM8.57857 8.89172V17.6597M16.4071 4.65802L12.4929 6.77487L8.57857 8.89172M4.66429 2.70401L12.4929 6.77487",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackSalesIcon);
export default __webpack_public_path__ + "static/media/black_sales_icon.1534f5ec74f8112d7ba9e6b04152cef5.svg";
export { ForwardRef as ReactComponent };